// SignUpPage.jsx

import { useTranslation } from 'react-i18next';
import RegisterComponent from './RegisterComponent';

function SignUpPage() {
  const { t } = useTranslation();

  return (
    <div className="auth-page">
      <div className="auth-card auth-card--wide">
        <h1>{t('sign_up', 'Sign up')}</h1>
        <RegisterComponent
          onSuccess={() => alert(t('confirmation_message', 'Account created successfully'))}
        />
        <p className="auth-footer-text">
          {t('already_have_account', 'Already have an account?')}{' '}
          <a href="/login" className="btn-link">
            {t('login', 'Log in')}
          </a>
        </p>
      </div>
    </div>
  );
}

export default SignUpPage;